
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CloseIconComponent } from "./close-icon.svg";

export const CloseIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CloseIconComponent {...props} />;
};
